
angular.module('admin')
.directive('onEnter',function(){
	return function(scope,element,attrs) {
		element.bind("keypress", function(event) {
			if(event.which === 13) {
				scope.$apply(attrs.onEnter);
				event.preventDefault();
			}
		});
	}
});

